<template>

		<div class="font-specimen-block-container Canal">
			<FontSpecimenVariableElement name="Canal Doppler Variable" sampleText="Energie" weight="100" id="cv1" min=100 max=900 step=100 />
			<FontSpecimenVariableElement name="Canal Doppler Variable" sampleText="Passion" weight="900" id="cv2"  min=100 max=900 step=100 />
			<FontSpecimenVariableElement name="Canal Doppler Variable" sampleText="Feel the force" weight="900" id="cv3" min=100 max=900 step=100 />
		</div>

</template>

<script>
import FontSpecimenVariableElement from "./elements/FontSpecimenVariableElement.vue";

export default {
	components: {
		FontSpecimenVariableElement,
	},
};
</script>
